module.exports = __webpack_public_path__ + "fonts/icomoon-bold.f595968.eot";